"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _DarkBoxInput = _interopRequireDefault(require("../../../Input/DarkBoxInput"));

var _TextButton = _interopRequireDefault(require("../../../Button/DarkButton/TextButton"));

var _IconPlus = _interopRequireDefault(require("../../../Icons/IconPlus"));

var _DarkText = _interopRequireDefault(require("../../../DarkText"));

var _IconButton = _interopRequireDefault(require("../../../Button/DarkButton/IconButton"));

var _IconClose = _interopRequireDefault(require("../../../Icons/IconClose"));

var _consts = require("../consts");

var _styles = require("../common/styles");

var _PollOptionImage = _interopRequireDefault(require("../PollResults/PollOptionImage"));

var _styles2 = require("./styles");

function AddNewOptionButton(_ref) {
  var poll = _ref.poll,
      dispatch = _ref.dispatch;
  var pollId = poll.pollId;
  var onAddOption = (0, _react.useCallback)(function () {
    dispatch({
      type: _consts.PollTeacherActions.ADD_NEW_OPTION,
      payload: {
        pollId: pollId
      }
    });
  }, [dispatch, pollId]);
  return _react.default.createElement(_TextButton.default, {
    className: (0, _classnames.default)(_styles2.addNewOptionStyles, 'add-new-option'),
    onClick: onAddOption
  }, _react.default.createElement(_IconPlus.default, {
    className: "plus-icon"
  }), _react.default.createElement(_DarkText.default, {
    as: "span",
    color: "amethyst"
  }, "Add an option"));
}

function PollOptions(_ref2) {
  var poll = _ref2.poll,
      dispatch = _ref2.dispatch;
  var pollId = poll.pollId,
      status = poll.status;

  var onDeleteOption = function onDeleteOption(optionId) {
    return function () {
      dispatch({
        type: _consts.PollTeacherActions.DELETE_OPTION,
        payload: {
          pollId: pollId,
          optionId: optionId
        }
      });
    };
  };

  var onOptionChange = function onOptionChange(optionId) {
    return function (event) {
      var value = event.target.value;
      dispatch({
        type: _consts.PollTeacherActions.OPTION_TEXT_CHANGE,
        payload: {
          pollId: pollId,
          optionId: optionId,
          value: value
        }
      });
    };
  };

  var options = poll.options;
  var optionsKeys = Object.keys(options);
  return optionsKeys.map(function (key) {
    return _react.default.createElement("div", {
      className: (0, _classnames.default)((0, _styles2.pollOption)(status, options[key].imageUrl), _styles.flexAlignCenterStretch, 'poll-option'),
      key: key
    }, _react.default.createElement(_PollOptionImage.default, {
      poll: poll,
      optionId: key,
      option: options[key],
      dispatch: dispatch
    }), _react.default.createElement(_DarkBoxInput.default, {
      placeholder: "Option",
      className: (0, _classnames.default)('poll-option-input', _styles2.resetInput),
      value: options[key].text,
      onChange: onOptionChange(key)
    }), optionsKeys.length > 2 ? _react.default.createElement(_IconButton.default, {
      className: "delete-option",
      onClick: onDeleteOption(key),
      tabIndex: "-1"
    }, _react.default.createElement(_IconClose.default, null)) : null);
  });
}

function PollQuestionInput(_ref3) {
  var poll = _ref3.poll,
      dispatch = _ref3.dispatch;
  var pollId = poll.pollId,
      question = poll.question;
  var onQuestionChange = (0, _react.useCallback)(function (event) {
    var value = event.target.value;
    dispatch({
      type: _consts.PollTeacherActions.QUESTION_TEXT_CHANGE,
      payload: {
        pollId: pollId,
        value: value
      }
    });
  }, [dispatch, pollId]);
  return _react.default.createElement(_DarkBoxInput.default, {
    placeholder: "Enter your question here",
    className: (0, _classnames.default)('poll-question-input', _styles2.resetInput),
    value: question,
    onChange: onQuestionChange
  });
}

function PollEditor(_ref4) {
  var poll = _ref4.poll,
      dispatch = _ref4.dispatch;
  return _react.default.createElement("div", {
    className: _styles2.pollEditorHeader
  }, _react.default.createElement(PollQuestionInput, {
    poll: poll,
    dispatch: dispatch
  }), _react.default.createElement(PollOptions, {
    poll: poll,
    dispatch: dispatch
  }), _react.default.createElement(AddNewOptionButton, {
    poll: poll,
    dispatch: dispatch
  }));
}

var _default = PollEditor;
exports.default = _default;